import React, { useState, useEffect } from 'react';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { db } from '../../firebase/firebase';
import ThemeSwitcher from '../common/ThemeSwitcher';

const Settings = () => {
    const [isEnabled, setIsEnabled] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [message, setMessage] = useState('');

    const settingsDocRef = doc(db, 'settings', 'registration');

    useEffect(() => {
        const fetchSettings = async () => {
            try {
                const docSnap = await getDoc(settingsDocRef);
                if (docSnap.exists()) {
                    setIsEnabled(docSnap.data().enabled);
                }
            } catch (error) {
                setMessage(`Error fetching settings: ${error.message}`);
            } finally {
                setIsLoading(false);
            }
        };
        fetchSettings();
    }, []);

    const handleToggle = async () => {
        setIsLoading(true);
        const newState = !isEnabled;
        try {
            await setDoc(settingsDocRef, { enabled: newState }, { merge: true });
            setIsEnabled(newState);
            setMessage(`Public registration has been ${newState ? 'enabled' : 'disabled'}.`);
        } catch (error) {
            setMessage(`Error updating settings: ${error.message}`);
        } finally {
            setIsLoading(false);
            setTimeout(() => setMessage(''), 3000);
        }
    };

    return (
        <div className="flex flex-col items-center justify-center w-full h-full pt-16 px-4 sm:px-0">
            <div className="w-full max-w-md p-6 sm:p-8 space-y-6 bg-white rounded-lg shadow-md dark:bg-gray-800 border-gray-200 dark:border-gray-700">
                <h1 className="text-2xl font-bold text-center text-gray-800 dark:text-gray-200">Application Settings</h1>

                <div className="space-y-4">
                    <h2 className="text-lg font-semibold text-gray-800 dark:text-gray-200 border-b pb-2 dark:border-gray-600">General</h2>
                    <div className="flex items-center justify-between p-4 border rounded-lg dark:border-gray-700">
                        <span className="text-gray-700 dark:text-gray-300">Enable Public Registration</span>
                        <button
                            onClick={handleToggle}
                            disabled={isLoading}
                            className={`relative inline-flex items-center h-6 rounded-full w-11 transition-colors duration-300 focus:outline-none ${isEnabled ? 'bg-blue-600' : 'bg-gray-400 dark:bg-gray-600'}`}
                        >
                            <span
                                className={`inline-block w-4 h-4 transform bg-white rounded-full transition-transform duration-300 ${isEnabled ? 'translate-x-6' : 'translate-x-1'}`}
                            />
                        </button>
                    </div>
                </div>

                <div className="space-y-4">
                     <h2 className="text-lg font-semibold text-gray-800 dark:text-gray-200 border-b pb-2 dark:border-gray-600">Appearance</h2>
                     <div className="flex items-center justify-between p-4 border rounded-lg dark:border-gray-700">
                        <span className="text-gray-700 dark:text-gray-300">Theme</span>
                        <ThemeSwitcher />
                    </div>
                </div>

                 {message && <p className="text-sm text-center text-gray-600 dark:text-gray-400 mt-4">{message}</p>}
                 {isLoading && isEnabled !== null && <p className="text-sm text-center text-gray-500 dark:text-gray-400">Updating...</p>}
            </div>
        </div>
    );
};

export default Settings;
